import { render, staticRenderFns } from "./campaign_create.vue?vue&type=template&id=818c160e&"
import script from "./campaign_create.vue?vue&type=script&lang=js&"
export * from "./campaign_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports